import React from "react";
import styles from "./FilterReview.module.scss";
import {useProductListContext} from "../../ProductListProvider/ProductListProvider";
import {CancelFilterButton} from "../../../ShopRating/ShopRatingSection";
import {ProductListFilterItemBoolean, ProductListFilterItemSelect} from "@connox/typescript-library";
import {currencyFormatter, genericFormatter} from "../ProductFilterRange/ProductFilterRange";
import {useTranslation} from "react-i18next";
import ResetFiltersLink from "../ResetFiltersLink/ResetFiltersLink";

const FilterReview: React.FC = () => {
  const {state, dispatch} = useProductListContext();
  const {t} = useTranslation();
  const {filters, instance} = state;

  const filterValues = instance?.filter.filterItems;
  const filtersEntries = Object.entries(filters);

  if (!filtersEntries.length || !filterValues) {
    return null;
  }

  const onRemoveSelectFilter = (field: string, value: string) => {
    const filterValue = filters[field] as string[];
    const newFilterValue = filterValue.filter((_value) => _value !== value);
    if (newFilterValue.length) {
      dispatch({
        type: "SET_FILTER",
        payload: {field, value: newFilterValue},
      });
    } else {
      dispatch({type: "REMOVE_FILTER", payload: {field}});
    }

    dispatch({type: "TRIGGER"});
  };

  const onRemoveFilter = (field: string) => {
    dispatch({type: "REMOVE_FILTER", payload: {field}});
  };

  return (
    <div>
      {filtersEntries.map(([key, keyValue]) => {
        if (typeof keyValue === "boolean") {
          if (!keyValue) {
            return null;
          }
          const filterValue = filterValues?.get(key) as ProductListFilterItemBoolean;

          return (
            <CancelFilterButton
              key={key}
              onCancel={() => {
                onRemoveFilter(key);
              }}
              className={styles.cancelButtonWrapper}
            >
              {filterValue.name || t(filterValue.field)}
            </CancelFilterButton>
          );
        }

        if (Array.isArray(keyValue)) {
          if (!keyValue.length) {
            return null;
          }
          const filterValue = filterValues?.get(key) as ProductListFilterItemSelect;

          return (
            <div key={key} className={styles.arrayWrapper}>
              {keyValue.map((value) => {
                return (
                  <CancelFilterButton
                    key={value}
                    onCancel={() => {
                      onRemoveSelectFilter(key, value);
                    }}
                    className={styles.cancelButtonWrapper}
                  >
                    {filterValue.rootValues.get(value)?.name}
                  </CancelFilterButton>
                );
              })}
            </div>
          );
        }

        if (typeof keyValue === "object") {
          const currency =
            currencyFormatter.formatToParts(42).find((part) => part.type === "currency")?.value ??
            window.c_ActiveCurrency;

          const limit = state.rangeFilterMap?.get(key);
          if (!limit) {
            return null;
          }

          if (keyValue.min === limit.min && keyValue.max === limit.max) {
            return null;
          }

          return (
            <CancelFilterButton
              key={key}
              onCancel={() => {
                onRemoveFilter(key);
              }}
              className={styles.cancelButtonWrapper}
            >
              {`${genericFormatter.format(keyValue.min)} - ${genericFormatter.format(keyValue.max)} ${
                key === "price" ? currency : "g"
              }`}
            </CancelFilterButton>
          );
        }

        return null;
      })}

      <ResetFiltersLink />
    </div>
  );
};

export default FilterReview;
